import { observable, action } from 'mobx'
import { fetchSsoCode, SsoCodeResult } from 'pages/Home/ServiceDesk/api'
import modulesStore from './modulesStore.store'
import orgs from 'store/orgs.store'

// The url is opened from a window that shares our origin, so anything but
// https (a javascript: url above all) must not get through.
const isSafeRedirect = (url: unknown): url is string => {
  if (typeof url !== 'string') {
    return false
  }
  try {
    return new URL(url).protocol === 'https:'
  } catch {
    return false
  }
}

class ServiceDeskStore {
  @observable loading = false

  // The module's external_url is the service desk API; the page people land on
  // comes back from it as redirectUrl, already carrying the sso code.
  @action openSso = async (): Promise<string | null> => {
    const serviceDeskModule = modulesStore.serviceDeskModule
    const moduleId = serviceDeskModule?.module_id
    const communityId = orgs.currentOrgId
    const baseUrl = typeof serviceDeskModule?.external_url === 'string' ? serviceDeskModule.external_url.trim() : ''
    if (!moduleId || typeof communityId !== 'number' || !baseUrl) {
      return null
    }
    const apiUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`

    this.loading = true
    try {
      let res = await this.requestCode(moduleId, communityId, apiUrl)
      //a stale mekome token gets one retry with a fresh one
      if (res?.unauthorized) {
        res = await this.requestCode(moduleId, communityId, apiUrl)
      }
      const redirectUrl = res?.redirectUrl
      return isSafeRedirect(redirectUrl) ? redirectUrl : null
    } finally {
      this.loading = false
    }
  }

  private requestCode = async (moduleId: number, communityId: number, apiUrl: string): Promise<SsoCodeResult> => {
    const authToken = await modulesStore.openServiceDeskModule(moduleId, communityId)
    if (!authToken) {
      return null
    }
    return fetchSsoCode(apiUrl, authToken, communityId)
  }
}

const serviceDeskStore = new ServiceDeskStore()
export default serviceDeskStore
